import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const PatternMaster = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [patternsCompleted, setPatternsCompleted] = useState(0);

  const generateQuestion = () => {
    const patterns = [
      { sequence: [5, 10, 15, 20], answer: 25, rule: '+5' },
      { sequence: [2, 4, 8, 16], answer: 32, rule: '×2' },
      { sequence: [100, 90, 80, 70], answer: 60, rule: '-10' },
      { sequence: [3, 6, 9, 12], answer: 15, rule: '+3' },
      { sequence: [50, 45, 40, 35], answer: 30, rule: '-5' },
      { sequence: [1, 4, 7, 10], answer: 13, rule: '+3' },
    ];
    const q = patterns[Math.floor(Math.random() * patterns.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = parseInt(userAnswer);
    if (answer === question.answer) {
      setScore(score + 10);
      setPatternsCompleted(patternsCompleted + 1);
      setFeedback(`✅ Correct! Pattern: ${question.rule}`);
      setTimeout(generateQuestion, 2000);
    } else {
      setFeedback(`❌ Wrong! Answer: ${question.answer} (Pattern: ${question.rule})`);
      setTimeout(generateQuestion, 3000);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-500 via-pink-500 to-red-500 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-300">← Back</button>
            <h1 className="text-3xl font-bold">🔢 Pattern Master</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">🔄</div>
            <h2 className="text-2xl font-bold text-gray-800">Complete the Pattern!</h2>
            <p className="text-gray-600">Patterns Completed: {patternsCompleted}</p>
          </div>

          {question && (
            <div className="text-center">
              <div className="flex justify-center items-center gap-4 mb-8">
                {question.sequence.map((num, idx) => (
                  <div key={idx} className="w-16 h-16 bg-purple-100 border-4 border-purple-500 rounded-lg flex items-center justify-center text-2xl font-bold text-purple-700">
                    {num}
                  </div>
                ))}
                <div className="text-4xl text-purple-600">→</div>
                <div className="w-16 h-16 bg-yellow-100 border-4 border-yellow-500 rounded-lg flex items-center justify-center text-3xl font-bold text-yellow-700">
                  ?
                </div>
              </div>

              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <input
                  type="number"
                  value={userAnswer}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="w-full text-4xl text-center border-4 border-purple-300 rounded-lg p-4 mb-4 focus:border-purple-500 focus:outline-none"
                  placeholder="?"
                  autoFocus
                />
                <button type="submit" className="w-full bg-purple-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-purple-700">
                  Submit Answer
                </button>
              </form>

              {feedback && (
                <div className={`mt-4 text-lg font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PatternMaster;